// @ts-nocheck
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { auth, googleProvider, appleProvider } from '../config/firebase';
import { signInWithEmailAndPassword, signInWithPopup, sendPasswordResetEmail } from 'firebase/auth';
import toast from 'react-hot-toast';

export default function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError('Invalid email or password');
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');
    try {
      await signInWithPopup(auth, googleProvider);
      navigate('/dashboard');
    } catch (err) {
      console.error('Google Sign In error:', err);
      setError('Google Sign In failed');
      setLoading(false);
    }
  };

  const handleAppleSignIn = async () => {
    setLoading(true);
    setError('');
    try {
      await signInWithPopup(auth, appleProvider);
      navigate('/dashboard');
    } catch (err) {
      console.error('Apple Sign In error:', err);
      setError('Apple Sign In failed');
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      toast.error('Bitte gib deine E-Mail-Adresse ein');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      toast.success('Password-Reset-Link wurde an deine E-Mail gesendet!');
    } catch (err) {
      console.error('Password reset error:', err);
      toast.error('Fehler beim Senden des Password-Reset-Links');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #FF6B35 0%, #FFD23F 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '3rem 2rem',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src="/logo-primary.png"
            alt="VoltFox Logo"
            style={{
              maxWidth: '350px',
              width: '100%',
              height: 'auto',
              marginBottom: '1rem'
            }}
          />
          <p style={{ color: '#666', marginTop: '0.5rem' }}>
            {t('auth.login.title')}
          </p>
        </div>

        {error && (
          <div style={{
            background: '#FEE2E2',
            color: '#DC2626',
            padding: '0.75rem',
            borderRadius: '8px',
            marginBottom: '1rem'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              color: '#2E3A4B',
              fontWeight: '500'
            }}>
              {t('auth.login.email')}
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #E5E7EB',
                borderRadius: '10px',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder={t('auth.login.emailPlaceholder')}
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              color: '#2E3A4B',
              fontWeight: '500'
            }}>
              {t('auth.login.password')}
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #E5E7EB',
                borderRadius: '10px',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder={t('auth.login.passwordPlaceholder')}
            />
          </div>

          <div style={{ marginBottom: '2rem', textAlign: 'right' }}>
            <button
              type="button"
              onClick={handlePasswordReset}
              style={{
                background: 'none',
                border: 'none',
                color: '#FF6B35',
                fontSize: '0.9rem',
                fontWeight: '600',
                cursor: 'pointer',
                textDecoration: 'underline',
                padding: 0
              }}
              onMouseOver={(e) => (e.currentTarget.style.color = '#FFD23F')}
              onMouseOut={(e) => (e.currentTarget.style.color = '#FF6B35')}
            >
              Passwort vergessen?
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '1rem',
              background: loading ? '#ccc' : 'linear-gradient(135deg, #FF6B35 0%, #FFD23F 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? t('auth.login.submitting') : t('auth.login.submit')}
          </button>
        </form>

        <div style={{
          margin: '2rem 0',
          textAlign: 'center',
          color: '#9CA3AF'
        }}>
          {t('auth.login.or')}
        </div>

        <button
          onClick={handleGoogleSignIn}
          disabled={loading}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: 'white',
            color: '#2E3A4B',
            border: '2px solid #E5E7EB',
            borderRadius: '10px',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            marginBottom: '0.75rem'
          }}
        >
          <span style={{ fontSize: '1.2rem' }}>🌐</span>
          {t('auth.login.google')}
        </button>

        <button
          onClick={handleAppleSignIn}
          disabled={loading}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '10px',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem'
          }}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6133 9.41309C14.625 11.9355 16.8047 12.7676 16.8281 12.7793C16.8086 12.8379 16.4648 14.0332 15.6094 15.2637C14.8594 16.3301 14.0859 17.3906 12.8789 17.4141C11.6953 17.4375 11.2852 16.6816 9.92969 16.6816C8.57422 16.6816 8.11719 17.3906 7.00391 17.4375C5.84375 17.4844 4.94531 16.2891 4.18359 15.2227C2.625 13.0313 1.44141 9.01172 3.04688 6.25781C3.84375 4.88672 5.25 4.05469 6.78516 4.03125C7.92188 4.00781 9.01172 4.83984 9.71484 4.83984C10.418 4.83984 11.7305 3.84375 13.125 3.98438C13.7227 4.00781 15.3984 4.21875 16.4531 5.78906C16.3711 5.84766 14.6016 6.91406 14.6133 9.41309ZM12.0703 2.53125C12.6914 1.77734 13.1133 0.738281 12.9844 -0.28125C12.0938 -0.246094 11.0039 0.339844 10.3594 1.08203C9.78516 1.74609 9.26953 2.80859 9.42188 3.82031C10.418 3.89844 11.4492 3.28516 12.0703 2.53125Z" fill="white"/>
          </svg>
          Mit Apple anmelden
        </button>

        <p style={{
          textAlign: 'center',
          marginTop: '2rem',
          color: '#666'
        }}>
          {t('auth.login.noAccount')}{' '}
          <Link to="/signup" style={{
            color: '#FF6B35',
            fontWeight: 'bold',
            textDecoration: 'none'
          }}>
            {t('auth.login.signUp')}
          </Link>
        </p>

        <p style={{
          textAlign: 'center',
          marginTop: '2rem',
          fontSize: '0.85rem',
          color: '#9CA3AF'
        }}>
          <a
            href="https://mr-vision.ch"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#9CA3AF',
              textDecoration: 'none',
              transition: 'color 0.2s'
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#FF6B35')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#9CA3AF')}
          >
            {t('common.createdBy')} ✨
          </a>
        </p>
      </div>
    </div>
  );
}
